module.exports = __webpack_public_path__ + "img/sale.d3e1a4fe.svg";